/* WEBSITES */
export const GET_WEBSITES = "GET_WEBSITES"
export const GET_WEBSITES_SUCCESS = "GET_WEBSITES_SUCCESS"
export const GET_WEBSITES_FAIL = "GET_WEBSITES_FAIL"